import React, { useEffect } from "react";

const DigilockerCallback = () => {
  useEffect(() => {
    // Notify parent window if opened as popup
    try {
      if (window.opener) {
        window.opener.postMessage({ type: "DIGILOCKER_CALLBACK_COMPLETE" }, "*");
      }
    } catch (e) {
      console.error(e);
    }

    // Auto-close popup after short delay
    const timer = setTimeout(() => {
      window.close();
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6 text-center">
      <div className="bg-white p-8 rounded-3xl shadow-xl max-w-sm w-full border border-gray-100 flex flex-col items-center">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
          <svg
            className="w-9 h-9 text-green-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-1">
          Verification Complete
        </h2>
        <p className="text-xs text-gray-500 mb-6 leading-relaxed">
          Your DigiLocker Aadhaar verification has been processed successfully.
          This window will close automatically.
        </p>
        <button
          onClick={() => window.close()}
          className="w-full bg-primaryColor text-white py-3 rounded-xl text-sm font-semibold hover:bg-primaryColor/90 transition active:scale-[0.98]"
        >
          Close Window
        </button>
      </div>
    </div>
  );
};

export default DigilockerCallback;
